import request from './request.js'

// 列表（如需）
export function getWebList(params = {}) {
  return request({
    url: '/soil/info/webList',
    method: 'GET',
    params
  })
}

// 详情
export function getWebInfoDetail(id) {
  return request({
    url: `/soil/info/webInfo/${encodeURIComponent(id)}`,
    method: 'GET'
  })
}

// 新增（后端若为其它路径，请告知）
export function createWebInfo(data) {
  return request({
    url: '/soil/info/webList',
    method: 'POST',
    data
  })
}

// 获取联系方式
export function getContactInfo(id) {
  return request({
    url: `/soil/info/contact/${encodeURIComponent(id)}`,
    method: 'GET'
  })
}



